// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__AFnJU","header":"PatientQuestionnaire_header__y2jXM","info":"PatientQuestionnaire_info__3f-Mi"};